const DRAFT = 'draft';
const PENDING = 'pending';
const ACTIVE = 'active';
const PAUSED = 'paused';
const COMPLETED = 'completed';

const VALUE_TO_LABEL = {
    [DRAFT]: 'Draft',
    [PENDING]: 'Pending',
    [ACTIVE]: 'Active',
    [PAUSED]: 'Paused',
    [COMPLETED]: 'Completed'
};

module.exports = Object.freeze({
    DRAFT: DRAFT,
    PENDING: PENDING,
    PAUSED: PAUSED,
    COMPLETED: COMPLETED,

    valueToLabel: function (value) {
        return VALUE_TO_LABEL[value];
    },
});
